'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-pure.js
// module id = 351
// module chunks = 22